import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import { useSelector } from "react-redux";
import styles from "../../shared/styles";
import { global, colors } from "../../utils";
import { Header, Label, Form } from "../../components/SharedComponents";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import localize from "../../shared/localize";

export default function SignupSuccess(props) {
    const userInfo = useSelector(({ auth }) => auth.userInfo)
    const invitedUser = useSelector(({ auth }) => auth.invitedUser)
    if (!userInfo) {
        props.history.push("SignIn")
        return null;
    }
    const redirect = userInfo.family_name === "" ? "Join-family" : "Join-family-success";
    return (
        <View style={styles.container}>
            {!global.isNative && (<Header title={localize.Signup_Success} />)}
            <ScrollView style={pageStyles.container}>
                <Icon
                    icon={faCheckCircle}
                    color={colors.green}
                    style={{ alignSelf: "center", position: "static", fontSize: 80, marginBottom: 40 }}
                />
                <Label.PrimaryTitle>
                    {`${localize.Hi} ${userInfo.nickname},`}
                </Label.PrimaryTitle>
                <Label.PrimaryTitle>
                    {`       ${localize.Thank_you_for_signing_up_with_Daily_Vitals}`}
                </Label.PrimaryTitle>
                <View style={{ paddingVertical: 10 }}>
                    <Label.PrimaryTitle color={colors.green}>
                        {
                            userInfo.family_name !== "" && `${localize.you_are_now_connected_to_your_friend} ${invitedUser && invitedUser.nickname} ${localize.who_sent_you_the_invitation_link}`
                        }
                    </Label.PrimaryTitle>
                </View>
                <View style={{ height: 20 }} />
                <Form.Button
                    title={localize.Continue}
                    onPress={() => props.history.push({ pathname: redirect })}
                    size="small"
                />
            </ScrollView>
        </View>
    )
}

const pageStyles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 20
    }
})